// A live Core card (shared/API.md §40): the integration card shell (MessageRow's AttachmentCard —
// accent rule + wash, hairline), accent by `status.tone`, the small-caps label line with the Satori
// Core mark, a bold one-line title, the subtitle, the status pill, fields two per row and
// «Actualizado hace N min». The whole card opens the record in Core (a new tab). All text is Core's.
import type { CSSProperties } from 'react';
import { CoreLinkCards, type CoreCard } from '../../../core/coreLinkCards';
import { useMinuteClock } from '../../hooks';
import './coreCards.css';

export function CoreCardView({ card, href }: { card: CoreCard; href: string }) {
  const now = useMinuteClock();
  const token = CoreLinkCards.toneToken(card.status?.tone);
  const updated = CoreLinkCards.updatedLabel(card.updatedAt, now);
  return (
    <a
      className="attachment-card accented core-card"
      href={card.url || href}
      target="_blank"
      rel="noreferrer noopener"
      data-core-kind={card.kind}
      style={{ '--card-accent': `var(--${token})` } as CSSProperties}
    >
      <div className="rule" />
      <div className="body">
        <div className="core-card-label">
          <span className="core-mark" aria-hidden>
            S
          </span>
          <span>{card.label || 'Satori Core'}</span>
        </div>
        <div className="core-card-head">
          <div className="title core-card-title">{card.title}</div>
          {card.status ? <span className={`core-pill tone-${token}`}>{card.status.label}</span> : null}
        </div>
        {card.subtitle ? <div className="core-card-subtitle">{card.subtitle}</div> : null}
        {card.fields.length ? (
          <div className="fields">
            {CoreLinkCards.fieldRows(card.fields).map((row, i) => (
              <div key={i} className={`field-row${row.length === 2 ? ' pair' : ' half'}`}>
                {row.map((f, j) => (
                  <div key={j} className="card-field">
                    <div className="field-title">{f.label}</div>
                    <div className="core-field-value">{f.value}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ) : null}
        {updated ? <div className="core-card-footer">{updated}</div> : null}
      </div>
    </a>
  );
}
